import { MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons'

import type { OrganisationInterface } from '@/types'

import OrganisationBadges from '../OrganisationBadges/OrganisationBadges'
import generalCn from '../OrganisationsSearch.module.scss'

type OrganisationListItemContentPropsType = {
  organisation: OrganisationInterface
  withEmail?: boolean
}

function OrganisationListItemContent({
  organisation,
  withEmail = true,
}: OrganisationListItemContentPropsType) {
  const initials = organisation.description
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('')

  const manager = organisation.supervisorManagerShortModel?.description
  const phone = organisation.phoneNumber || organisation.contactPhone
  const email = withEmail ? organisation.email : ''

  return (
    <>
      <div
        className={generalCn.listItemAvatar}
        data-legal={organisation.isLegal}
      >
        {initials || <UserOutlined />}
      </div>

      <div className={generalCn.listItemBody}>
        <div className={generalCn.listItemLine1}>
          <span className={generalCn.listItemName}>
            {organisation.description}
          </span>
          <OrganisationBadges organisation={organisation} />
        </div>

        <span className={generalCn.listItemMeta}>
          {manager && (
            <span className={generalCn.metaItem}>
              <UserOutlined />
              {manager}
            </span>
          )}
          {phone && (
            <span className={generalCn.metaItem}>
              <PhoneOutlined />
              {phone}
            </span>
          )}
          {email && (
            <span className={generalCn.metaItem}>
              <MailOutlined />
              {email}
            </span>
          )}
        </span>
      </div>
    </>
  )
}

export default OrganisationListItemContent
